import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/expense-records', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/expense-records', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/expense-records/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = data => {
  return httpClient
    .put(`/api/expense-records/${data.expense_id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
  return httpClient
    .delete(`/api/expense-records/${id}`)
    .then(response => Promise.resolve(response.data))
}

export const getExpenseItem = (Options = {}) => {
  return httpClient
    .get('/api/expense-records/expense-items', Option)
    .then(response => Promise.resolve(response.data))
}

export const getCurrency = (Options = {}) => {
  return httpClient
    .get('/api/expense-records/currencies', Option)
    .then(response => Promise.resolve(response.data))
}

export default {
  get,
  store,
  find,
  update,
  destroy,
  getExpenseItem,
  getCurrency
}
